/* HERS Kinetic — shared behaviour. Every block is independent: if one fails,
   the rest keep working, and the store still works with none of it. */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var S = window.HERS_T || {};
  var FMT = window.HERS_MONEY || '{{amount}}';
  function safe(fn) { try { fn(); } catch (e) { if (window.console) console.warn('[hers]', e); } }
  function money(c) {
    /* some shops' plain format is just the number — fall back to the one with the
       currency so prices never appear bare */
    var bare = String(FMT).replace(/<[^>]*>/g, '').replace(/\{\{[^}]*\}\}/g, '');   /* ignore tags and the placeholder */
    if (!/[A-Za-z\u0600-\u06FF$€£]/.test(bare) && window.HERS_MONEY_CUR) FMT = window.HERS_MONEY_CUR;
    var n = (c / 100).toFixed(2);
    var withCommas = n.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return FMT.replace(/\{\{\s*amount_no_decimals[^}]*\}\}/, withCommas.split('.')[0])
              .replace(/\{\{\s*amount[^}]*\}\}/, withCommas);
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  function sized(url, w) { if (!url) return ''; if (!/^(https?:)?\/\//.test(url)) return url; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function lock(on) { document.documentElement.style.overflow = on ? 'hidden' : ''; }
  /* Chat widgets from apps are fixed to the screen at the highest z-index and
     land on top of the bag. Hide any fixed element that looks like one while a
     panel is open, and put it back afterwards. */
  var hiddenWidgets = [];
  function hideWidgets() {
    document.querySelectorAll('body > *, body > * > *').forEach(function (el) {
      if (el.closest('.kd,.kq,.kp,.k-menu,.hers-header,.hers-announce,.k-shipbar,.k-sticky,.k-toast')) return;
      var id = ((el.id || '') + ' ' + (typeof el.className === 'string' ? el.className : '')).toLowerCase();
      if (!/whats|wa-|wa_|chat|messenger|tidio|crisp|intercom|zendesk|livechat/.test(id)) return;
      var st = getComputedStyle(el);
      if (st.position !== 'fixed' || st.visibility === 'hidden') return;
      hiddenWidgets.push([el, el.style.visibility]);
      el.style.visibility = 'hidden';
    });
  }
  /* Apps place their bubbles at the bottom of the screen without knowing about
     the tab bar or the shipping bar. Lift any such fixed widget above them —
     including ones an app injects after the page has loaded. */
  function isChatWidget(el) {
    if (!el || el.nodeType !== 1 || el.closest('.kd,.kq,.kp,.k-menu,.k-tabbar,.k-shipbar,.k-sticky,.k-toast,.k-wa')) return false;
    var id = ((el.id || '') + ' ' + (typeof el.className === 'string' ? el.className : '')).toLowerCase();
    if (!/whats|wa-|wa_|chat|messenger|tidio|crisp|intercom|zendesk|livechat/.test(id)) return false;
    return getComputedStyle(el).position === 'fixed';
  }
  function liftWidgets() {
    document.querySelectorAll('body > *, body > * > *').forEach(function (el) {
      if (!el.classList.contains('k-lifted') && isChatWidget(el)) el.classList.add('k-lifted');
    });
  }
  safe(function () {
    liftWidgets();
    if ('MutationObserver' in window) {
      var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(liftWidgets, 150); })
        .observe(document.body, { childList: true, subtree: false });
    }
    [1500, 4000, 8000].forEach(function (ms) { setTimeout(liftWidgets, ms); });
  });

  function showWidgets() {
    hiddenWidgets.forEach(function (w) { w[0].style.visibility = w[1]; });
    hiddenWidgets = [];
  }
  function openLayer(el) {
    if (!el) return; el.hidden = false;
    requestAnimationFrame(function () { el.classList.add('on'); });
    lock(true); document.documentElement.classList.add('k-layer-open'); hideWidgets();
  }
  function closeLayer(el) {
    if (!el || el.hidden) return; el.classList.remove('on'); lock(false);
    setTimeout(function () {
      el.hidden = true;
      if (!document.querySelector('.kd.on,.kq.on,.kp.on,.k-menu.on')) {
        document.documentElement.classList.remove('k-layer-open'); showWidgets();
      }
    }, 320);
  }

  /* ---------- toast ---------- */
  function toast(msg) {
    var t = document.getElementById('k-toast'); if (!t) return;
    t.textContent = msg; t.classList.add('on');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('on'); }, 2400);
  }
  window.hersToast = toast;

  /* ---------- cart state ---------- */
  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      if (n > 0) el.removeAttribute('data-empty'); else el.setAttribute('data-empty', '');
      el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump');
      setTimeout(function () { el.classList.remove('bump'); }, 320);
    });
  }
  function getCart() { return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }


  /* ---------- bottom free-shipping bar ---------- */
  function paintShipBar(cart) {
    var bar = document.getElementById('k-shipbar');
    if (!bar) return;
    var goal = parseInt(bar.dataset.goal, 10) || 0;
    var show = goal > 0 && cart.item_count > 0 && !bar.dataset.off;
    bar.hidden = !show;
    document.documentElement.style.setProperty('--k-sb', show ? (window.innerWidth <= 760 ? '46px' : '48px') : '0px');
    if (!show) return;
    var left = goal - cart.total_price;
    bar.classList.toggle('is-done', left <= 0);
    bar.querySelector('[data-sb-text]').textContent = left > 0
      ? (S.shipLeft || 'Add __ for free shipping').replace('__', money(left))
      : '✦ ' + (S.shipDone || 'Free shipping unlocked');
    bar.querySelector('[data-sb-fill]').style.width = Math.min(100, cart.total_price / goal * 100) + '%';
    bar.querySelector('[data-sb-total]').textContent = money(cart.total_price);
  }
  window.hersPaintShipBar = paintShipBar;


  /* ---------- arrival date: worked out in the customer's own time zone ---------- */
  var D = window.HERS_DELIVERY || {};
  if (D.min == null) D.min = 2;
  if (D.max == null) D.max = 3;
  if (D.cutoff == null) D.cutoff = 16;
  if (!D.closed) D.closed = 'fri';
  function closedDays() {
    if (D.closed === 'frisat') return [5, 6];
    if (D.closed === 'sun') return [0];
    if (D.closed === 'none') return [];
    return [5];                                   /* Friday */
  }
  function addWorkingDays(from, days) {
    var d = new Date(from.getTime()), closed = closedDays(), left = days;
    while (left > 0) { d.setDate(d.getDate() + 1); if (closed.indexOf(d.getDay()) === -1) left--; }
    while (closed.indexOf(d.getDay()) !== -1) d.setDate(d.getDate() + 1);
    return d;
  }
  function paintDeliveryDate() {
    var els = document.querySelectorAll('[data-delivery-date]');
    /* only stay quiet if it was deliberately switched off */
    if (!els.length || D.on === false) return;
    var now = new Date(), start = new Date(now.getTime()), sameDay = now.getHours() < (D.cutoff == null ? 16 : D.cutoff);
    if (!sameDay) start.setDate(start.getDate() + 1);
    var a = addWorkingDays(start, D.min || 2), b = addWorkingDays(start, Math.max(D.max || 3, D.min || 2));
    var loc = (D.locale === 'ar' ? 'ar-EG' : 'en-GB');
    var fmtDay = { weekday: 'short', day: 'numeric' }, fmtFull = { weekday: 'short', day: 'numeric', month: 'short' };
    var range;
    try {
      range = (a.toDateString() === b.toDateString())
        ? b.toLocaleDateString(loc, fmtFull)
        : a.toLocaleDateString(loc, a.getMonth() === b.getMonth() ? fmtDay : fmtFull) + ' – ' + b.toLocaleDateString(loc, fmtFull);
    } catch (e) { return; }
    var line;
    if (D.style !== 'dates') {
      /* plain and short: "Arrives in 2 days" */
      var n = D.min || 2;
      var key = n === 1 ? (S.etaOneDay || 'Arrives tomorrow')
              : n === 2 ? (S.etaTwoDays || 'Arrives in 2 days')
              : (S.etaDays || 'Arrives in {{ n }} days').replace('{{ n }}', n);
      line = key;
    } else {
      line = (sameDay ? (S.etaToday || 'Order today, arrives {{ range }}') : (S.etaPlain || 'Arrives {{ range }}'))
        .replace('{{ range }}', range);
    }
    els.forEach(function (el) { el.textContent = line; el.hidden = false; });
  }
  safe(paintDeliveryDate);

  /* ---------- what the bag saves you ---------- */
  var comparePrices = {};
  function savingsFor(cart) {
    var saved = 0, waits = [];
    cart.items.forEach(function (it) {
      saved += (it.original_line_price || it.final_line_price) - it.final_line_price;   /* discounts */
      var handle = (it.url || '').split('?')[0].split('/products/')[1];
      if (!handle) return;
      var known = comparePrices[handle];
      var job = known ? Promise.resolve(known)
        : fetch(root + 'products/' + handle + '.js').then(function (r) { return r.ok ? r.json() : null; })
            .then(function (p) { comparePrices[handle] = p; return p; }).catch(function () { return null; });
      waits.push(job.then(function (p) {
        if (!p) return 0;
        var v = (p.variants || []).filter(function (x) { return x.id === it.variant_id || x.id === it.id; })[0];
        if (v && v.compare_at_price > v.price) return (v.compare_at_price - v.price) * it.quantity;
        return 0;
      }));
    });
    return Promise.all(waits).then(function (extra) {
      return saved + extra.reduce(function (a, b) { return a + b; }, 0);
    });
  }
  function tidy(v) { return String(v || '').trim().toUpperCase(); }

  /* Shopify reports a discount in different places depending on how it was set up:
     on the order, on the cart, or allocated across the individual lines. Look in all
     of them, and count it only when money actually came off. */
  function discountFor(cart, code) {
    var want = tidy(code), hit = null;
    var pools = [cart.cart_level_discount_applications, cart.discount_applications];
    (cart.items || []).forEach(function (it) {
      pools.push(it.line_level_discount_allocations, it.discounts, it.discount_allocations);
    });
    pools.forEach(function (list) {
      (list || []).forEach(function (d) {
        if (hit) return;
        var title = d.title || d.description || (d.discount_application && d.discount_application.title);
        if (tidy(title) !== want) return;
        var amount = d.total_allocated_amount;
        if (amount === undefined) amount = d.amount;
        if (amount === undefined) amount = (cart.total_discount || 0);
        if (amount > 0) hit = { title: title, amount: amount };
      });
    });
    return hit;
  }

  function codeOnCart(cart) {
    var code = (document.querySelector('.kd-code__chip b') || {}).textContent || '';
    if (!code) return '';
    var hit = discountFor(cart, code);
    return hit ? hit.title : '';
  }

  /* what delivery will cost, said in the bag rather than sprung at checkout */
  function paintDelivery(cart) {
    var row = document.querySelector('[data-kd-ship-row]');
    var dueRow = document.querySelector('[data-kd-due-row]');
    if (!row) return;
    var fee = parseInt(window.HERS_DELIVERY_FEE, 10) || 0;
    var bar = document.getElementById('k-shipbar');
    var goal = bar ? parseInt(bar.dataset.goal, 10) : 0;
    if (!fee || !cart.item_count) { row.hidden = true; if (dueRow) dueRow.hidden = true; return; }

    var free = goal > 0 && (cart.total_price || 0) >= goal;
    var cost = free ? 0 : fee;
    var costEl = row.querySelector('[data-kd-ship-cost]');
    if (costEl) {
      costEl.textContent = free ? (S.freeDelivery || 'Free') : money(cost);
      costEl.classList.toggle('is-free', free);
    }
    row.hidden = false;
    if (dueRow) {
      var due = dueRow.querySelector('[data-kd-due]');
      if (due) due.textContent = money((cart.total_price || 0) + cost);
      dueRow.hidden = false;
    }
  }

  function paintSavings(cart) {
    var row = document.querySelector('[data-kd-save]');
    var flag = document.querySelector('[data-kd-codeflag]');
    if (flag) {
      var on = codeOnCart(cart);
      flag.textContent = on ? on + ' ' + (S.codeApplied || 'applied') : '';
      flag.hidden = !on;
    }
    if (!row) return;
    if (!cart.item_count) { row.hidden = true; return; }
    savingsFor(cart).then(function (total) {
      if (total > 0) { row.querySelector('[data-kd-save-amount]').textContent = money(total); row.hidden = false; }
      else row.hidden = true;
    }).catch(function () {});
  }

  /* ---------- discount code straight from the bag ---------- */
  safe(function () {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-code-apply]');
      if (!btn) return;
      var box = btn.closest('.kd-code'), input = box.querySelector('[data-code-input]');
      var code = (input.value || '').trim();
      if (!code) { input.focus(); return; }
      btn.disabled = true;
      /* Shopify applies the code and carries it into checkout */
      location.href = root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(root + 'checkout');
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.matches('[data-code-input]')) {
        e.preventDefault();
        e.target.closest('.kd-code').querySelector('[data-code-apply]').click();
      }
    });
  });


  /* ---------- little extras: hide what is already in the bag, keep it short ---------- */
  function paintExtras(cart) {
    var box = document.querySelector('[data-extras]');
    if (!box) return;
    var onProductPage = !!box.dataset.skip;
    var want = parseInt(box.dataset.want, 10) || 3;
    var inBag = {};
    (cart.items || []).forEach(function (it) { inBag[it.product_id] = true; });
    var shown = 0;
    box.querySelectorAll('[data-extra-add]').forEach(function (b) {
      var already = inBag[b.dataset.extraProduct];
      var room = shown < want;
      var show = !already && room;
      b.hidden = !show;
      if (show) shown++;
    });
    /* on a product page it stands on its own; in the bag it only makes sense with items */
    box.hidden = shown === 0 || (!onProductPage && !cart.item_count);
  }

  safe(function () {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-extra-add]');
      if (!b || b.dataset.busy) return;
      b.dataset.busy = '1';
      b.classList.add('is-adding');
      addVariant(b.dataset.extraAdd)
        .catch(function (err) {                    /* only a real add failure is an error */
          toast((err && err.description) || S.error || 'Something went wrong');
          throw err;
        })
        .then(function () {
          return getCart().then(function (cart) {
            setCount(cart.item_count);
            if (refreshCartPage()) return;
            try { paintDrawer(cart); } catch (e) { paintExtras(cart); }
            if (typeof openDrawer === 'function' && drawer) openDrawer();
          }).catch(function () {});
        })
        .catch(function () {})
        .then(function () { b.classList.remove('is-adding'); delete b.dataset.busy; });
    });
  });

  /* ---------- drawer ---------- */
  var drawer = document.getElementById('k-drawer');
  var recCache = {};


  /* ---------- a few pounds short of free shipping? show what would cover it ---------- */
  function paintGapPicks(cart) {
    var box = document.querySelector('[data-gap-picks]');
    if (!box) return;
    var bar = document.getElementById('k-shipbar');
    var goal = bar ? parseInt(bar.dataset.goal, 10) : 0;
    var left = goal - (cart.total_price || 0);
    if (!goal || !cart.item_count || left <= 0) { box.hidden = true; return; }

    var inBag = {};
    (cart.items || []).forEach(function (it) { inBag[it.product_id] = true; });

    var picks = [].slice.call(box.querySelectorAll('[data-extra-add]'))
      .filter(function (b) { return !inBag[b.dataset.extraProduct]; })
      .map(function (b) { return { el: b, price: parseInt(b.dataset.price, 10) || 0 }; });

    /* the ones that close the gap, cheapest first; if none do, the dearest that get closest */
    var covers = picks.filter(function (p) { return p.price >= left; }).sort(function (a, b) { return a.price - b.price; });
    var closest = picks.filter(function (p) { return p.price < left; }).sort(function (a, b) { return b.price - a.price; });
    /* if anything covers the gap, offer only those, so the heading is always true */
    var chosen = covers.length ? covers.slice(0, 3) : closest.slice(0, 3);

    picks.forEach(function (p) { p.el.hidden = true; });
    chosen.forEach(function (p) { p.el.hidden = false; });

    var title = box.querySelector('[data-gap-title]');
    /* only claim free shipping when something here actually covers what is missing */
    var covers_gap = covers.length > 0;
    if (title) {
      title.textContent = covers_gap
        ? (S.gapTitle || 'Any of these gets you free shipping')
        : (S.gapCloser || 'Add {{ amount }} more for free shipping').replace('{{ amount }}', money(left));
    }
    box.hidden = chosen.length === 0;
  }



  /* The cart page's totals are drawn by Shopify, not by us — so after anything that
     changes the cart there, the page has to be redrawn or it shows stale numbers. */
  function onCartPage() {
    return document.body.classList.contains('t-cart') ||
           /\/cart(\/|$|\?)/.test(location.pathname);
  }
  function refreshCartPage() {
    if (onCartPage()) { location.reload(); return true; }
    return false;
  }



  /* ---------- search opens over the page, not on another page ---------- */
  safe(function () {
    var panel = document.getElementById('k-search');
    if (!panel) return;
    var input = panel.querySelector('[data-search-input]');

    function open() {
      panel.hidden = false;
      requestAnimationFrame(function () { panel.classList.add('on'); });
      document.documentElement.style.overflow = 'hidden';
      setTimeout(function () { if (input) input.focus(); }, 120);
    }
    function close() {
      panel.classList.remove('on');
      document.documentElement.style.overflow = '';
      setTimeout(function () { if (!panel.classList.contains('on')) panel.hidden = true; }, 240);
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-open-search]')) { e.preventDefault(); open(); }
      else if (e.target.closest('[data-search-close]')) close();
    });
    addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
      /* "/" opens it, the way people expect on a shop */
      if (e.key === '/' && !/^(INPUT|TEXTAREA)$/.test((document.activeElement || {}).tagName)) { e.preventDefault(); open(); }
    });
    window.hersOpenSearch = open;
  });

  /* ---------- saved products, kept on this device ---------- */
  safe(function () {
    var KEY = 'hers_wish';
    var read = function () {
      try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
    };
    var write = function (list) {
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    };

    function paintCount() {
      var n = read().length;
      document.querySelectorAll('[data-wish-count]').forEach(function (b) {
        b.textContent = n;
        if (n) b.removeAttribute('data-empty'); else b.setAttribute('data-empty', '');
      });
    }

    function paintHearts() {
      var list = read();
      document.querySelectorAll('[data-wish]').forEach(function (h) {
        var on = list.indexOf(h.dataset.wish) > -1;
        h.classList.toggle('is-on', on);
        h.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    document.addEventListener('click', function (e) {
      var heart = e.target.closest('[data-wish]');
      if (!heart) return;
      e.preventDefault();
      e.stopPropagation();                       /* don't follow the card's link */
      var handle = heart.dataset.wish, list = read();
      var at = list.indexOf(handle);
      if (at > -1) list.splice(at, 1); else list.unshift(handle);
      write(list.slice(0, 50));
      paintHearts(); paintCount();
    });

    /* the panel */
    var panel = document.getElementById('k-wish');
    function fill() {
      if (!panel) return;
      var list = read();
      var box = panel.querySelector('[data-wish-list]');
      var empty = panel.querySelector('[data-wish-empty]');
      box.innerHTML = '';
      if (!list.length) { if (empty) empty.hidden = false; return; }
      if (empty) empty.hidden = true;
      Promise.all(list.map(function (h) {
        return fetch(root + 'products/' + h + '.js')
          .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      })).then(function (ps) {
        box.innerHTML = ps.filter(Boolean).map(function (p) {
          var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0] || {};
          return '<div class="kw-line">' +
            '<a class="kw-pic" href="' + esc(p.url) + '">' + (p.featured_image ? '<img src="' + esc(p.featured_image) + '&width=160" alt="">' : '') + '</a>' +
            '<div><a class="kd-name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
            '<span class="kw-price">' + money(p.price) + '</span>' +
            '<div class="kw-acts">' +
            (v.id ? '<button type="button" class="kw-add" data-extra-add="' + v.id + '">' + esc(S.addToBag || 'Add to bag') + '</button>' : '') +
            '<button type="button" class="kw-rm" data-wish="' + esc(p.handle) + '">' + esc(S.wishRemove || 'Remove') + '</button>' +
            '</div></div></div>';
        }).join('');
        paintHearts();
      });
    }

    function open() {
      if (!panel) return;
      fill();
      panel.hidden = false;
      requestAnimationFrame(function () { panel.classList.add('on'); });
      document.documentElement.style.overflow = 'hidden';
    }
    function close() {
      if (!panel) return;
      panel.classList.remove('on');
      document.documentElement.style.overflow = '';
      setTimeout(function () { if (!panel.classList.contains('on')) panel.hidden = true; }, 260);
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-open-wish]')) { e.preventDefault(); open(); }
      else if (e.target.closest('[data-wish-close]')) close();
    });
    addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    /* removing from inside the panel should redraw it */
    if (panel) panel.addEventListener('click', function (e) {
      if (e.target.closest('.kw-rm')) setTimeout(fill, 30);
    });

    paintHearts(); paintCount();
    window.hersOpenWish = open;
  });

  /* ---------- bundles: offer the swap when a bag holds the parts ---------- */
  var BUNDLES = null;
  function bundleList() {
    if (BUNDLES) return BUNDLES;
    var tag = document.querySelector('[data-bundles]');
    try { BUNDLES = tag ? JSON.parse(tag.textContent) : []; } catch (e) { BUNDLES = []; }
    return BUNDLES;
  }

  function paintSwap(cart) {
    var box = document.querySelector('[data-bundle-swap]');
    if (!box) return;
    var list = bundleList();
    if (!list.length || !cart.item_count) { box.hidden = true; return; }

    var inBag = {};
    (cart.items || []).forEach(function (it) { inBag[it.product_id] = it; });

    var best = null;
    list.forEach(function (b) {
      var have = b.parts.filter(function (id) { return inBag[id]; });
      if (have.length < 2) return;                       /* one part is not a bundle */
      var spend = have.reduce(function (sum, id) { return sum + (inBag[id].final_line_price || 0); }, 0);
      var saving = spend - b.price;
      if (saving <= 0) return;                           /* only offer it if it really saves */
      if (!best || saving > best.saving) best = { b: b, have: have, saving: saving };
    });

    if (!best) { box.hidden = true; return; }
    box.innerHTML =
      '<p class="kd-swap__title">' + (S.swapTitle || 'These come as a bundle') + '</p>' +
      '<div class="kd-swap__row"><span class="kd-swap__name">' + esc(best.b.title) + '</span>' +
      '<button type="button" class="kd-swap__go" data-swap="' + best.b.id + '">' +
      (S.swapDo || 'Swap and save {{ amount }}').replace('{{ amount }}', money(best.saving)) + '</button></div>';
    box.dataset.parts = best.have.join(',');
    box.hidden = false;
  }

  safe(function () {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-swap]');
      if (!btn || btn.dataset.busy) return;
      btn.dataset.busy = '1';
      var box = btn.closest('[data-bundle-swap]');
      var parts = (box.dataset.parts || '').split(',').filter(Boolean).map(Number);
      getCart().then(function (cart) {
        /* take the separate items out, put the bundle in */
        var updates = {};
        (cart.items || []).forEach(function (it) {
          if (parts.indexOf(it.product_id) > -1) updates[it.key] = 0;
        });
        return fetch(root + 'cart/update.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function () { return addVariant(btn.dataset.swap); });
      })
        .catch(function (err) {                  /* only a real failure is an error */
          toast(S.error || 'Something went wrong');
          throw err;
        })
        .then(function () {
          return getCart().then(function (cart) {
            if (refreshCartPage()) return;
            try { paintDrawer(cart); } catch (e) {}
            toast(S.swapped || 'Swapped for the bundle');
          }).catch(function () {});
        })
        .catch(function () {})
        .then(function () { delete btn.dataset.busy; });
    });
  });

  function paintDrawer(cart) {
    paintDelivery(cart);
    paintSwap(cart);
    paintGapPicks(cart);
    paintExtras(cart);
    paintSavings(cart);
    paintDeliveryDate();
    try { localStorage.setItem('hers_bag', JSON.stringify({ n: cart.item_count, at: Date.now() })); } catch (e) {}
    paintShipBar(cart);
    if (!drawer) return;
    setCount(cart.item_count);
    var lines = drawer.querySelector('[data-kd-lines]');
    var foot = drawer.querySelector('[data-kd-foot]');
    var note = drawer.querySelector('[data-kd-note]');
    if (note && document.activeElement !== note) note.value = cart.note || '';

    /* free shipping */
    var goal = parseInt(drawer.dataset.goal, 10) || 0;
    var ship = drawer.querySelector('[data-kd-ship]');
    if (ship) {
      ship.hidden = !goal || !cart.item_count;
      if (goal) {
        var left = goal - cart.total_price;
        drawer.querySelector('[data-kd-ship-text]').textContent =
          left > 0 ? (S.shipLeft || 'Add __ for free shipping').replace('__', money(left)) : (S.shipDone || 'Free shipping unlocked');
        drawer.querySelector('[data-kd-ship-fill]').style.width = Math.min(100, cart.total_price / goal * 100) + '%';
      }
    }

    if (!cart.item_count) {
      lines.innerHTML = '<p class="kd-empty">' + esc(S.empty || 'Your bag is empty.') + '</p>';
      foot.hidden = true;
    } else {
      foot.hidden = false;
      drawer.querySelector('[data-kd-total]').textContent = money(cart.total_price);
      lines.innerHTML = cart.items.map(function (it, i) {
        var variant = it.product_has_only_default_variant ? '' : '<small>' + esc(it.variant_title || '') + '</small>';
        return '<div class="kd-line" data-kd-line="' + (i + 1) + '">' +
          '<a href="' + it.url + '">' + (it.image ? '<img src="' + sized(it.image, 200) + '" alt="" loading="lazy">' : '<span class="kd-ph"></span>') + '</a>' +
          '<div><a class="kd-name" href="' + it.url + '">' + esc(it.product_title) + '</a>' + variant +
            '<div class="kd-row"><span class="k-qty"><button type="button" data-kd-step="-1" aria-label="−">−</button>' +
            '<input value="' + it.quantity + '" readonly aria-label="qty">' +
            '<button type="button" data-kd-step="1" aria-label="+">+</button></span>' +
            '<button type="button" class="kd-rm" data-kd-rm>' + esc(S.remove || 'Remove') + '</button></div></div>' +
          '<strong>' + money(it.final_line_price) + '</strong></div>';
      }).join('');
    }
    loadRecs(cart);
  }

  function loadRecs(cart) {
    var box = drawer.querySelector('[data-kd-recs]'), rail = drawer.querySelector('[data-kd-rail]');
    if (!box) return;
    if (!cart.item_count) { box.hidden = true; return; }
    var pid = cart.items[0].product_id, inCart = cart.items.map(function (i) { return i.product_id; });
    function ask(intent) {
      return fetch(root + 'recommendations/products.json?product_id=' + pid + '&limit=8&intent=' + intent)
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (d) { return (d && d.products) || []; }).catch(function () { return []; });
    }
    function render(list) {
      list = list.filter(function (p) { return p.available !== false && inCart.indexOf(p.id) === -1; }).slice(0, 6);
      if (!list.length) { box.hidden = true; return; }
      rail.innerHTML = list.map(function (p) {
        var img = p.featured_image ? (typeof p.featured_image === 'string' ? p.featured_image : p.featured_image.url) : '';
        var v = (p.variants || [])[0];
        var single = (p.variants || []).length === 1;
        return '<div class="kd-rec"><a href="' + p.url + '">' + (img ? '<img src="' + sized(img, 300) + '" alt="" loading="lazy">' : '') + '</a>' +
          '<a class="kd-name" href="' + p.url + '">' + esc(p.title) + '</a><span>' + money(p.price) + '</span>' +
          (single && v ? '<button type="button" class="kd-recadd" data-kd-add="' + v.id + '">+</button>'
                       : '<button type="button" class="kd-recadd" data-quick-view="' + p.url + '">+</button>') + '</div>';
      }).join('');
      box.hidden = false;
    }
    if (recCache[pid]) return render(recCache[pid]);
    ask('complementary').then(function (a) { return a.length ? a : ask('related'); })
      .then(function (a) { recCache[pid] = a; render(a); });
  }

  function openDrawer() {
    if (!drawer) { location.href = root + 'cart'; return; }
    getCart().then(paintDrawer).catch(function () {});
    openLayer(drawer);
  }
  window.hersOpenCart = openDrawer;

  function change(line, qty) {
    return fetch(root + 'cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json(); }).then(paintDrawer);
  }

  function addVariant(id, qty) {
    return fetch(root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: qty || 1 }] })
    }).then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); });
  }

  safe(function () {
    if (!drawer) return;
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-drawer-close]')) { closeLayer(drawer); return; }
      var step = e.target.closest('[data-kd-step]'), rm = e.target.closest('[data-kd-rm]');
      if (step || rm) {
        var line = e.target.closest('[data-kd-line]'); var n = parseInt(line.dataset.kdLine, 10);
        var q = parseInt(line.querySelector('input').value, 10);
        change(n, rm ? 0 : Math.max(0, q + parseInt(step.dataset.kdStep, 10)));
      }
      var ra = e.target.closest('[data-kd-add]');
      if (ra) {
        ra.textContent = '…';
        addVariant(ra.dataset.kdAdd).then(function () { return getCart(); }).then(paintDrawer)
          .catch(function (err) { ra.textContent = '!'; toast((err && err.description) || S.error); });
      }
    });
    var note = drawer.querySelector('[data-kd-note]'), nt;
    if (note) note.addEventListener('input', function () {
      clearTimeout(nt);
      nt = setTimeout(function () {
        fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: note.value }) });
      }, 600);
    });
  });

  /* ---------- quick add (home cards, product cards, product page) ---------- */
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('form[data-quick-add], form.rh-add, form.k-add, form.k-qa');
    if (!f) return;
    e.preventDefault();
    var b = f.querySelector('button[type="submit"]');
    var label = b ? b.innerHTML : '';
    if (b) { b.disabled = true; b.dataset.busy = '1'; }
    fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(f) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function () { if (drawer) openDrawer(); else toast(S.added || 'Added to your bag'); })
      .catch(function (err) { toast((err && err.description) || S.error || 'Could not add that'); })
      .finally(function () { if (b) { b.innerHTML = label; b.disabled = false; delete b.dataset.busy; } });
  });

  /* ---------- quick view: also the variant picker for multi-option products ---------- */
  var qv = document.getElementById('k-quick');
  var qcache = {};
  function renderQuick(p) {
    var body = qv.querySelector('[data-quick-body]');
    var vs = p.variants || [];
    var first = vs.filter(function (v) { return v.available; })[0] || vs[0];
    var imgs = (p.images || []).slice(0, 5);
    var sel = vs.length > 1 ? '<label class="kq-label">' + esc(S.choose || 'Choose') + '<select class="k-field" data-qv-variant>' +
      vs.map(function (v) {
        var vimg = (v.featured_image && v.featured_image.src) || '';
        return '<option value="' + v.id + '" data-price="' + v.price + '" data-compare="' + (v.compare_at_price || '') + '"' +
          (vimg ? ' data-img="' + vimg + '"' : '') +
          (v.available ? '' : ' disabled') + (first && v.id === first.id ? ' selected' : '') + '>' + esc(v.title) +
          (v.available ? '' : ' — ' + esc(S.soldOut)) + '</option>';
      }).join('') + '</select></label>' : '';
    var onSale = first && first.compare_at_price > first.price;
    body.innerHTML =
      '<div class="kq-media"><img data-qv-main src="' + sized(imgs[0], 900) + '" alt="">' +
        (imgs.length > 1 ? '<div class="kq-thumbs">' + imgs.map(function (i, n) {
          return '<button type="button" data-qv-img="' + sized(i, 900) + '" class="' + (n ? '' : 'on') + '"><img src="' + sized(i, 160) + '" alt=""></button>';
        }).join('') + '</div>' : '') + '</div>' +
      '<div class="kq-info"><h3>' + esc(p.title) + '</h3>' +
        '<div class="kq-price"><strong data-qv-price>' + (first ? money(first.price) : '') + '</strong>' +
        '<s data-qv-compare' + (onSale ? '' : ' hidden') + '>' + (onSale ? money(first.compare_at_price) : '') + '</s></div>' +
        sel +
        '<button class="k-pill is-solid kq-add" type="button" data-qv-add="' + (first ? first.id : '') + '"' +
          (first && first.available ? '' : ' disabled') + '>' + esc(first && first.available ? S.add : S.soldOut) + ' <b>+</b></button>' +
        '<div class="kq-desc">' + (p.description || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 240) + '…</div>' +
        '<a class="k-link" href="' + p.url + '">' + esc(S.full || 'See full details') + ' →</a></div>';
  }
  function openQuick(url) {
    if (!qv) { location.href = url; return; }
    var body = qv.querySelector('[data-quick-body]');
    body.innerHTML = '<p class="kq-loading">…</p>';
    openLayer(qv);
    if (qcache[url]) return renderQuick(qcache[url]);
    fetch(url.split('?')[0] + '.js').then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (p) { qcache[url] = p; renderQuick(p); })
      .catch(function () { location.href = url; });
  }
  safe(function () {
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-quick-view]');
      if (t) { e.preventDefault(); openQuick(t.dataset.quickView); return; }
      if (e.target.closest('[data-quick-close]')) { closeLayer(qv); return; }
      var th = e.target.closest('[data-qv-img]');
      if (th) {
        qv.querySelector('[data-qv-main]').src = th.dataset.qvImg;
        qv.querySelectorAll('[data-qv-img]').forEach(function (b) { b.classList.toggle('on', b === th); });
      }
      var add = e.target.closest('[data-qv-add]');
      if (add && !add.disabled) {
        add.disabled = true;
        addVariant(add.dataset.qvAdd).then(function () { closeLayer(qv); openDrawer(); })
          .catch(function (err) { toast((err && err.description) || S.error); })
          .finally(function () { add.disabled = false; });
      }
      if (e.target.closest('[data-open-cart]') && !e.metaKey && !e.ctrlKey) { e.preventDefault(); openDrawer(); }
    });
    document.addEventListener('change', function (e) {
      if (!e.target.matches('[data-qv-variant]')) return;
      var o = e.target.selectedOptions[0];
      qv.querySelector('[data-qv-price]').textContent = money(parseInt(o.dataset.price, 10));
      var c = qv.querySelector('[data-qv-compare]'), cp = parseInt(o.dataset.compare, 10);
      if (cp && cp > parseInt(o.dataset.price, 10)) { c.textContent = money(cp); c.hidden = false; } else { c.hidden = true; }
      var a = qv.querySelector('[data-qv-add]'); a.dataset.qvAdd = o.value; a.disabled = o.disabled;
      /* show that colour's photo */
      if (o.dataset.img) {
        var main = qv.querySelector('[data-qv-main]');
        if (main) main.src = sized(o.dataset.img, 900);
        var bare = function (u) { return String(u).split('?')[0].replace(/^https?:/, ''); };
        qv.querySelectorAll('[data-qv-img]').forEach(function (bt) {
          bt.classList.toggle('on', bare(bt.dataset.qvImg) === bare(o.dataset.img));
        });
      }
    });
  });

  /* ---------- escape closes whatever is open ---------- */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    ['k-drawer', 'k-quick', 'k-popup', 'k-menu'].forEach(function (id) { closeLayer(document.getElementById(id)); });
  });

  /* ---------- mobile menu ---------- */
  safe(function () {
    var menu = document.getElementById('k-menu');
    if (!menu) return;
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-menu-open]')) openLayer(menu);
      if (e.target.closest('[data-menu-close]')) closeLayer(menu);
      /* search has its own panel now — it must not open this menu as well */
    });
  });

  /* ---------- cart page steppers ---------- */
  safe(function () {
    var cart = document.querySelector('[data-k-cart]');
    if (!cart) return;
    cart.addEventListener('click', function (e) {
      var step = e.target.closest('[data-step]');
      if (!step) return;
      var line = step.closest('[data-line]'), input = line.querySelector('input[name="updates[]"]');
      var q = Math.max(0, parseInt(input.value, 10) + parseInt(step.dataset.step, 10));
      input.value = q;
      fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: parseInt(line.dataset.line, 10), quantity: q }) }).then(function () { location.reload(); });
    });
  });


  /* ---------- the offered code: tap to apply, tap again to remove ---------- */
  safe(function () {
    var busy = false;
    function setChips(state, code) {
      document.querySelectorAll('.kd-code__chip').forEach(function (c) {
        var label = code || (c.querySelector('b') || {}).textContent || '';
        var give = c.dataset.gives || (c.querySelector('span') ? c.querySelector('span').textContent : '');
        c.dataset.gives = give;                       /* what the code gives, e.g. 10% off */
        var tick = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 13l4 4L19 7"/></svg>';
        if (state === 'on') {
          c.classList.add('is-on');
          c.innerHTML = tick + '<b>' + label + '</b><span>' + give + '</span><em>' + (S.codeOn || 'applied') + '</em>';
        } else if (state === 'working') {
          c.innerHTML = '<b>' + label + '</b><span>' + give + '</span><em>…</em>';
        } else {
          c.classList.remove('is-on');
          c.innerHTML = '<b>' + label + '</b><span>' + give + '</span><em>' + (S.codeOff || 'tap to apply') + '</em>';
        }
      });
    }
    /* a code counts as applied when money actually came off for it — wherever
       Shopify put it: on the order, or spread across the lines */
    function cartHas(cart, code) { return !!discountFor(cart, code); }
    var lastTouch = 0;
    function onTap(e) {
      var chip = e.target.closest && e.target.closest('.kd-code__chip');
      if (!chip || busy) return;
      if (e.type === 'touchend') lastTouch = Date.now();
      else if (Date.now() - lastTouch < 600) return;    /* the tap already handled it */
      e.preventDefault();
      var code = (chip.querySelector('b') || {}).textContent || '';
      if (!code) return;
      var removing = chip.classList.contains('is-on');
      busy = true;
      setChips('working', code);
      /* Applying through the cart alone is unreliable — Shopify honours it only
         sometimes. Ask the shop to set the code the way a link would, then check;
         fall back to the cart if that fails. Removing works through the cart. */
      function viaCart(value) {
        return fetch(root + 'cart/update.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: value })
        }).then(function (r) { return r.ok ? r.json() : null; });
      }

      function viaLink(value) {
        return fetch(root + 'discount/' + encodeURIComponent(value), { credentials: 'same-origin' })
          .then(function () { return getCart(); })
          .catch(function () { return null; });
      }

      var work = removing
        ? viaCart('')
        : viaLink(code).then(function (cart) {
            if (cart && cartHas(cart, code)) return cart;      /* the link did it */
            return viaCart(code).then(function (c) {           /* otherwise try the cart */
              return c && cartHas(c, code) ? c : (c || cart);
            });
          });

      work
        .then(function (cart) {
          if (!cart) throw new Error('no cart');
          paintDrawer(cart);
          var on = cartHas(cart, code);
          setChips(on ? 'on' : 'off', code);
          if (refreshCartPage()) return;
          if (!removing && !on) {
            /* say it on the code itself, not only in a passing message */
            document.querySelectorAll('.kd-code__chip').forEach(function (c) {
              c.classList.add('is-bad');
              c.innerHTML = '<b>' + code + '</b><span>' + (c.dataset.gives || '') + '</span><em>' + (S.codeBad || 'not valid here') + '</em>';
              setTimeout(function () { c.classList.remove('is-bad'); setChips('off', code); }, 4000);
            });
            toast(S.codeFailed || 'That code is not available right now');
          }
          if (removing && on) toast(S.codeStuck || 'Remove it at checkout');
          busy = false;
        })
        .catch(function () {
          busy = false;
          setChips(removing ? 'on' : 'off', code);
          if (!removing) {                       /* older shops: let Shopify do it the long way */
            var href = chip.getAttribute('href');
            if (href) location.href = href;
          }
        });
    }
    document.addEventListener('click', onTap);
    document.addEventListener('touchend', onTap, { passive: false });
  });

  /* ---------- discount popup: once per visit, and again after a while ---------- */
  safe(function () {
    var pop = document.getElementById('k-popup');
    if (!pop) return;
    var K = 'hers_popup';
    var days = parseInt(pop.dataset.days, 10); if (isNaN(days)) days = 7;
    function seen() {
      try {
        if (sessionStorage.getItem(K) === 'seen') return true;          /* not twice in one visit */
        var taken = parseInt(localStorage.getItem(K), 10);              /* already took the code */
        if (!taken) return false;
        if (days === 0) return false;                                   /* show it every visit */
        return Date.now() - taken < days * 86400000;                    /* quiet for a while, then back */
      } catch (e) { return false; }
    }
    function mark(v) {
      try { if (v === 'done') localStorage.setItem(K, String(Date.now())); else sessionStorage.setItem(K, 'seen'); } catch (e) {}
    }
    var justSubscribed = pop.querySelector('.kp-done');
    if (justSubscribed) { mark('done'); openLayer(pop); }
    else if (!seen()) {
      var t = setTimeout(function () { mark('seen'); openLayer(pop); }, (parseInt(pop.dataset.delay, 10) || 12) * 1000);
      /* people leaving the tab on desktop get it sooner */
      document.addEventListener('mouseout', function (e) {
        if (!e.relatedTarget && e.clientY < 8 && !seen()) { clearTimeout(t); mark('seen'); openLayer(pop); }
      });
    }
    pop.addEventListener('click', function (e) {
      if (e.target.closest('[data-popup-close]')) closeLayer(pop);
      var c = e.target.closest('[data-copy]');
      if (!c) return;
      var code = c.dataset.copy;
      var done = function () {
        mark('done');                                   /* they have the code; don't ask again */
        c.classList.add('is-copied');
        toast(S.copied || 'Code copied');
        setTimeout(function () { closeLayer(pop); }, 900);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done).catch(function () { select(c); done(); });
      } else { select(c); done(); }
    });
    /* older phones: select the code so a long-press can copy it */
    function select(el) {
      try {
        var r = document.createRange(); r.selectNodeContents(el.querySelector('span') || el);
        var sel = window.getSelection(); sel.removeAllRanges(); sel.addRange(r);
      } catch (e) {}
    }
    var f = pop.querySelector('form'); if (f) f.addEventListener('submit', function () { mark('done'); });
  });

  /* ---------- sticky add to bag on the product page ---------- */
  safe(function () {
    var bar = document.getElementById('k-sticky'), real = document.querySelector('.hp-form button[type="submit"]');
    if (!bar || !real || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (es) {
      var gone = !es[0].isIntersecting && es[0].boundingClientRect.top < 0;
      bar.hidden = !gone; if (gone) requestAnimationFrame(function () { bar.classList.add('on'); }); else bar.classList.remove('on');
    }).observe(real);
    bar.querySelector('button').addEventListener('click', function () { real.click(); });
    var sel = document.querySelector('[data-variant-select]'), price = bar.querySelector('[data-sticky-price]');
    var thumb = bar.querySelector('[data-sticky-img]');
    if (sel) sel.addEventListener('change', function () {
      var o = sel.selectedOptions[0];
      if (price) price.innerHTML = o.dataset.price;
      /* the little picture follows the chosen colour too */
      if (thumb && o.dataset.imageId) {
        var shot = document.querySelector('.hp-gallery [data-img-id="' + o.dataset.imageId + '"] img');
        if (shot) {
          thumb.src = shot.currentSrc || shot.src;
          thumb.removeAttribute('srcset');
        }
      }
    });
  });



  /* ---------- product gallery: thumbnails and swiping ---------- */
  safe(function () {
    var gal = document.querySelector('.hp-gallery');
    if (!gal) return;
    var main = gal.querySelector('[data-gallery-main]');
    var shots = [].slice.call(gal.querySelectorAll('[data-shot]'));
    var thumbs = [].slice.call(gal.querySelectorAll('[data-thumb]'));
    if (!main || shots.length < 2) return;
    var wide = function () { return window.matchMedia('(min-width: 761px)').matches; };
    var show = function (n) {
      shots.forEach(function (s, i) { s.classList.toggle('is-active', i === n); });
      thumbs.forEach(function (t, i) {
        t.classList.toggle('is-active', i === n);
        t.setAttribute('aria-selected', i === n ? 'true' : 'false');
      });
      if (!wide()) main.scrollTo({ left: shots[n].offsetLeft - shots[0].offsetLeft, behavior: 'smooth' });
    };
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
    gal.showShot = show;                    /* the variant picker uses this */
    /* swiping on phones keeps the thumbnails in step */
    var tick;
    main.addEventListener('scroll', function () {
      if (wide()) return;
      clearTimeout(tick);
      tick = setTimeout(function () {
        var mid = main.scrollLeft + main.clientWidth / 2, best = 0, gap = Infinity;
        shots.forEach(function (s, i) {
          var c = s.offsetLeft - shots[0].offsetLeft + s.offsetWidth / 2, d = Math.abs(c - mid);
          if (d < gap) { gap = d; best = i; }
        });
        shots.forEach(function (s, i) { s.classList.toggle('is-active', i === best); });
        thumbs.forEach(function (t, i) {
          t.classList.toggle('is-active', i === best);
          t.setAttribute('aria-selected', i === best ? 'true' : 'false');
        });
      }, 90);
    }, { passive: true });
  });

  /* ---------- pickup: re-read when the customer picks another variant ---------- */
  safe(function () {
    var box = document.querySelector('[data-pickup-target]');
    var sel = document.querySelector('[data-variant-select]');
    if (!box || !sel) return;
    var url = (document.querySelector('link[rel="canonical"]') || {}).href || location.pathname;
    url = url.split('?')[0];
    var cache = {};
    sel.addEventListener('change', function () {
      var id = sel.value;
      if (cache[id] !== undefined) { box.innerHTML = cache[id]; return; }
      fetch(url + '?variant=' + encodeURIComponent(id) + '&section_id=k-pickup')
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (html === null) return;
          var wrap = document.createElement('div');
          wrap.innerHTML = html;
          var found = wrap.querySelector('.k-pickup');
          cache[id] = found ? found.outerHTML : '';
          box.innerHTML = cache[id];
        }).catch(function () {});
    });
  });


  /* ---------- "you may also like" on the product page ---------- */
  safe(function () {
    var box = document.querySelector('[data-recommendations]');
    if (!box || !box.dataset.url) return;
    var swap = function (html) {
      var wrap = document.createElement('div');
      wrap.innerHTML = html;
      var fresh = wrap.querySelector('[data-recommendations]');
      if (!fresh || !fresh.querySelector('.k-card')) return false;
      box.innerHTML = fresh.innerHTML;
      box.hidden = false;
      return true;
    };
    fetch(box.dataset.url)
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (html && swap(html)) return;
        /* nothing set up for this product: fall back to similar ones */
        if (!box.dataset.fallback || box.dataset.fallback === box.dataset.url) { box.hidden = true; return; }
        return fetch(box.dataset.fallback).then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (h2) { if (!h2 || !swap(h2)) box.hidden = true; });
      })
      .catch(function () { box.hidden = true; });
  });

  /* ---------- recently viewed ---------- */
  safe(function () {
    var KEY = 'hers_recent', here = document.querySelector('[data-recent-handle]');
    var list = []; try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) {}
    if (here) {
      var h = here.dataset.recentHandle;
      list = [h].concat(list.filter(function (x) { return x !== h; })).slice(0, 12);
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    }
    var box = document.querySelector('[data-recent]');
    if (!box) return;
    var skip = here ? here.dataset.recentHandle : null;
    var show = list.filter(function (x) { return x !== skip; }).slice(0, 5);
    if (!show.length) return;
    Promise.all(show.map(function (h) {
      return fetch(root + 'products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (ps) {
      ps = ps.filter(Boolean);
      if (!ps.length) return;
      box.querySelector('[data-recent-grid]').innerHTML = ps.map(function (p) {
        return '<article class="k-card"><a class="k-media" href="' + p.url + '">' +
          (p.featured_image ? '<img src="' + sized(p.featured_image, 600) + '" alt="" loading="lazy">' : '') + '</a>' +
          '<div class="k-copy"><div><h3><a href="' + p.url + '">' + esc(p.title) + '</a></h3><span>' + money(p.price) + '</span></div></div></article>';
      }).join('');
      box.hidden = false;
    });
  });

  safe(function () {
    if (!document.querySelector('[data-extras]')) return;
    getCart().then(paintExtras).catch(function () {});
  });





  /* ---------- what delivery will cost, asked of Shopify itself ---------- */
  safe(function () {
    document.querySelectorAll('[data-estimate]').forEach(function (wrap) {
    var go = wrap.querySelector('[data-est-go]');
    var out = wrap.querySelector('[data-est-out]');
    var sel = wrap.querySelector('[data-est-province]');
    if (!go || !out || !sel) return;

    go.addEventListener('click', function () {
      if (go.dataset.busy) return;
      go.dataset.busy = '1';
      out.textContent = (S.estimating || 'Checking…');
      var url = root + 'cart/shipping_rates.json?shipping_address%5Bcountry%5D=Egypt' +
                '&shipping_address%5Bprovince%5D=' + encodeURIComponent(sel.value);
      fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var rates = (d && d.shipping_rates) || [];
          if (!rates.length) { out.textContent = (S.estNone || 'No delivery to this governorate yet'); return; }
          out.innerHTML = rates.map(function (r) {
            var price = Math.round(parseFloat(r.price) * 100);
            return '<div class="k-est__rate"><span>' + esc(r.name) + '</span><strong>' +
              (price === 0 ? (S.freeDelivery || 'Free') : money(price)) + '</strong></div>';
          }).join('');
        })
        .catch(function () { out.textContent = (S.estFail || 'Could not check just now'); })
        .then(function () { delete go.dataset.busy; });
    });
    });
  });


  /* ---------- the Products tab opens the categories instead of jumping away ---------- */
  safe(function () {
    var sheet = document.getElementById('k-catsheet');
    var tab = document.querySelector('[data-open-cats]');
    if (!sheet || !tab) return;                       /* no menu set: leave the link alone */

    function open() {
      sheet.hidden = false;
      requestAnimationFrame(function () { sheet.classList.add('on'); });
      document.documentElement.style.overflow = 'hidden';
      tab.setAttribute('aria-expanded', 'true');
    }
    function close() {
      sheet.classList.remove('on');
      tab.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      setTimeout(function () { if (!sheet.classList.contains('on')) sheet.hidden = true; }, 240);
    }

    tab.setAttribute('aria-expanded', 'false');
    tab.addEventListener('click', function (e) {
      e.preventDefault();
      if (sheet.classList.contains('on')) close(); else open();
    });
    sheet.addEventListener('click', function (e) {
      if (e.target.closest('[data-sheet-close]')) close();
    });
    addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    /* swipe it down to dismiss */
    var startY = null;
    var panel = sheet.querySelector('.k-sheet__panel');
    panel.addEventListener('touchstart', function (e) {
      if (panel.scrollTop > 0) return;
      startY = e.touches[0].clientY;
    }, { passive: true });
    panel.addEventListener('touchmove', function (e) {
      if (startY === null) return;
      var d = e.touches[0].clientY - startY;
      if (d > 0) panel.style.transform = 'translateY(' + d + 'px)';
    }, { passive: true });
    panel.addEventListener('touchend', function () {
      if (startY === null) return;
      var moved = parseFloat((panel.style.transform.match(/([\d.]+)px/) || [0, 0])[1]);
      panel.style.transform = '';
      startY = null;
      if (moved > 70) close();
    });
  });

  /* ---------- tap a product photo to see it close up ---------- */
  safe(function () {
    var gal = document.querySelector('.hp-gallery');
    if (!gal) return;

    var box = null, img = null, scale = 1, panX = 0, panY = 0;

    function build() {
      box = document.createElement('div');
      box.className = 'k-zoom';
      box.innerHTML = '<button type="button" class="k-zoom__x" aria-label="' + (S.close || 'Close') + '">✕</button><img alt="">';
      img = box.querySelector('img');
      document.body.appendChild(box);
      box.addEventListener('click', function (e) { if (e.target !== img) close(); });
      box.querySelector('.k-zoom__x').addEventListener('click', close);
      img.addEventListener('click', function (e) {
        e.stopPropagation();
        if (scale === 1) {
          var r = img.getBoundingClientRect();
          scale = 2.4;
          panX = (r.width / 2 - (e.clientX - r.left)) * 1.4;
          panY = (r.height / 2 - (e.clientY - r.top)) * 1.4;
        } else { scale = 1; panX = 0; panY = 0; }
        apply();
      });
      /* drag to move around when zoomed in */
      var down = false, sx = 0, sy = 0, ox = 0, oy = 0;
      img.addEventListener('pointerdown', function (e) {
        if (scale === 1) return;
        down = true; sx = e.clientX; sy = e.clientY; ox = panX; oy = panY; img.setPointerCapture(e.pointerId);
      });
      img.addEventListener('pointermove', function (e) {
        if (!down) return;
        panX = ox + (e.clientX - sx); panY = oy + (e.clientY - sy); apply();
      });
      img.addEventListener('pointerup', function () { down = false; });
    }

    function apply() {
      img.style.transform = 'translate(' + panX + 'px,' + panY + 'px) scale(' + scale + ')';
      img.style.cursor = scale === 1 ? 'zoom-in' : 'grab';
    }

    function open(src) {
      if (!box) build();
      scale = 1; panX = 0; panY = 0;
      img.src = src;
      apply();
      box.classList.add('on');
      document.documentElement.style.overflow = 'hidden';
    }

    function close() {
      if (!box) return;
      box.classList.remove('on');
      document.documentElement.style.overflow = '';
    }

    addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    gal.addEventListener('click', function (e) {
      /* the click often lands on the frame rather than the photo itself */
      var shot = e.target.closest('.hp-shot');
      if (!shot || !shot.classList.contains('is-active')) return;
      var pic = shot.querySelector('img');
      if (!pic) return;
      var full = pic.currentSrc || pic.src;
      open(full.replace(/(\?|&)width=\d+/, '$1width=1600'));
    });
    gal.classList.add('is-zoomable');
  });

  /* ---------- sideways rows: arrows and drag, for mouse users ---------- */
  safe(function () {
    /* touch phones swipe naturally; anything else gets arrows (CSS hides them on small screens) */
    var touchOnly = window.matchMedia('(hover:none) and (pointer:coarse)').matches;

    function equip(row) {
      if (!row || row.dataset.slider) return;
      row.dataset.slider = '1';
      var wrap = row.parentNode;
      if (getComputedStyle(wrap).position === 'static') wrap.style.position = 'relative';

      var prev = document.createElement('button'), next = document.createElement('button');
      prev.type = next.type = 'button';
      prev.className = 'k-rail-arrow k-rail-arrow--prev';
      next.className = 'k-rail-arrow k-rail-arrow--next';
      prev.innerHTML = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg>';
      next.innerHTML = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg>';
      prev.setAttribute('aria-label', S.prev || 'Previous');
      next.setAttribute('aria-label', S.next || 'Next');
      wrap.appendChild(prev); wrap.appendChild(next);

      var step = function () { return Math.max(160, row.clientWidth * 0.7); };
      var rtl = document.documentElement.dir === 'rtl';
      prev.addEventListener('click', function () { row.scrollBy({ left: rtl ? step() : -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { row.scrollBy({ left: rtl ? -step() : step(), behavior: 'smooth' }); });

      var update = function () {
        var room = row.scrollWidth - row.clientWidth > 4;
        var x = Math.abs(row.scrollLeft);
        prev.hidden = !room || x < 4;
        next.hidden = !room || x > row.scrollWidth - row.clientWidth - 4;
      };
      row.addEventListener('scroll', update, { passive: true });
      addEventListener('resize', update);
      setTimeout(update, 60); update();
      row._railUpdate = update;

      /* drag with the mouse, like a trackpad swipe */
      var down = false, startX = 0, startLeft = 0, moved = false;
      row.addEventListener('mousedown', function (e) {
        if (e.button !== 0) return;
        down = true; moved = false; startX = e.pageX; startLeft = row.scrollLeft;
      });
      addEventListener('mousemove', function (e) {
        if (!down) return;
        var d = e.pageX - startX;
        /* only treat it as a drag once the mouse really moves, or a plain click
           would land on the row instead of the chip under it */
        if (Math.abs(d) > 3 && !moved) { moved = true; row.classList.add('is-dragging'); }
        if (moved) row.scrollLeft = startLeft - d;
      });
      addEventListener('mouseup', function () {
        if (!down) return;
        down = false; row.classList.remove('is-dragging');
        if (moved) {                                  /* a drag must not count as a tap */
          row.addEventListener('click', function stop(ev) { ev.preventDefault(); ev.stopPropagation(); row.removeEventListener('click', stop, true); }, true);
        }
      });
    }

    if (touchOnly) return;
    document.querySelectorAll('.kd-extras__row,.k-recs .k-grid,.k-recent .k-grid,.kd-rail').forEach(equip);
    /* rows that arrive later (the bag repainting, suggestions changing) */
    var mo = new MutationObserver(function () {
      document.querySelectorAll('.kd-extras__row,.kd-rail').forEach(function (r) {
        equip(r); if (r._railUpdate) r._railUpdate();
      });
    });
    mo.observe(document.body, { childList: true, subtree: true });
  });

  /* ---------- reviews: show a couple, then a button for the rest ---------- */
  safe(function () {
    var want = parseInt(window.HERS_REVIEWS_SHOW, 10);
    if (isNaN(want) || want < 1) want = 2;
    var btn = null, working = false, mo = null;

    function tidy() {
      if (working) return;                    /* our own edits must not retrigger this */
      working = true;
      if (mo) mo.disconnect();
      try { arrange(); } catch (e) {}
      if (mo && host) mo.observe(host, { childList: true, subtree: true });
      working = false;
    }

    function arrange() {
      var list = document.querySelector('.jdgm-rev-widg__reviews');
      if (!list) return;
      var all = [].slice.call(list.querySelectorAll('.jdgm-rev'));
      if (all.length <= want) { if (btn) { btn.remove(); btn = null; } return; }
      if (list.dataset.open === '1') return;                 /* already expanded */

      all.forEach(function (r, i) { r.hidden = i >= want; });
      var hidden = all.length - want;
      if (!btn) {
        btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'k-morerev';
        btn.addEventListener('click', function () {
          list.dataset.open = '1';
          all.forEach(function (r) { r.hidden = false; });
          btn.remove(); btn = null;
        });
        list.parentNode.insertBefore(btn, list.nextSibling);
      }
      var label = (S.moreReviews || 'Show all {{ count }} reviews').replace('{{ count }}', all.length);
      if (btn.textContent !== label) btn.textContent = label;
    }

    /* Judge.me fills the widget after the page loads, and again when paging */
    var host = document.getElementById('judgeme_product_reviews') || document.querySelector('.jdgm-review-widget');
    if (!host) return;
    mo = new MutationObserver(function () { tidy(); });
    mo.observe(host, { childList: true, subtree: true });
    tidy();
    setTimeout(tidy, 1200); setTimeout(tidy, 3000);
  });

  /* ---------- come back later with a full bag? one quiet reminder ---------- */
  safe(function () {
    if (/\/(cart|checkouts?)(\/|$)/.test(location.pathname)) return;
    var saved; try { saved = JSON.parse(localStorage.getItem('hers_bag') || 'null'); } catch (e) {}
    if (!saved || !saved.n) return;
    var waitHours = window.HERS_REMIND_AFTER;
    if (waitHours == null) waitHours = 6;
    if (Date.now() - saved.at < waitHours * 3600000) return;        /* same visit, no nagging */
    try { if (sessionStorage.getItem('hers_bag_nudge')) return; } catch (e) {}
    setTimeout(function () {
      getCart().then(function (cart) {
        if (!cart || !cart.item_count) return;
        try { sessionStorage.setItem('hers_bag_nudge', '1'); } catch (e) {}
        setCount(cart.item_count);
        var t = document.getElementById('k-toast');
        if (!t) return;
        t.textContent = (S.bagWaiting || 'Your bag is still here') + ' →';
        t.classList.add('on', 'is-tappable');
        t.onclick = function () { t.classList.remove('on', 'is-tappable'); openDrawer(); };
        clearTimeout(t._h);
        t._h = setTimeout(function () { t.classList.remove('on', 'is-tappable'); t.onclick = null; }, 7000);
      }).catch(function () {});
    }, 2500);
  });

  /* ---------- predictive search ---------- */
  safe(function () {
    document.querySelectorAll('input[data-predictive]').forEach(function (inp) {
      var out = document.createElement('div'); out.className = 'k-suggest'; out.hidden = true;
      inp.parentNode.style.position = 'relative'; inp.parentNode.appendChild(out);
      var t;
      inp.addEventListener('input', function () {
        clearTimeout(t); var q = inp.value.trim();
        if (q.length < 2) { out.hidden = true; return; }
        t = setTimeout(function () {
          fetch(root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
            .then(function (r) { return r.json(); })
            .then(function (d) {
              var ps = (d.resources && d.resources.results && d.resources.results.products) || [];
              if (!ps.length) { out.hidden = true; return; }
              out.innerHTML = ps.map(function (p) {
                return '<a href="' + p.url + '">' + (p.image ? '<img src="' + sized(p.image, 120) + '" alt="">' : '<span></span>') +
                  '<span>' + esc(p.title) + '</span><b>' + esc(p.price ? money(Math.round(parseFloat(p.price) * 100)) : '') + '</b></a>';
              }).join('');
              out.hidden = false;
            }).catch(function () { out.hidden = true; });
        }, 180);
      });
      document.addEventListener('click', function (e) { if (!out.contains(e.target) && e.target !== inp) out.hidden = true; });
    });
  });
})();
